type Arguments = {
	loanPercent: number
	periodYears: number // Указываем в годах
	sum: number
}

export const useCalculationResult = (args: Arguments) => {
	const { loanPercent, periodYears, sum } = args
	const paymentsCount = periodYears * 12
	const monthLoanPercent = loanPercent / (12 * 100)

	const a = monthLoanPercent * Math.pow(1 + monthLoanPercent, paymentsCount)
	const b = Math.pow(1 + monthLoanPercent, paymentsCount) - 1

	const x = a / b

	const result = sum * x

	if (Number.isFinite(result)) {
		return result
	}
	console.error(`Не удалось расчитать платёж, ${result}`)

	return 0
}
